<div class="modal-body">
  <div class="row">
    <div class="col-lg-12">
      <h5>Qui êtes-vous ?</h5>
      <p>
        Déjà inscrit? <a href="#" (click)="openAlreadyInscriptionModal()">clique-ici</a>
      </p>
    </div>

    <div class="col-lg-6 form-group">
      <label for="prenom">Prénom*</label>
      <dx-text-box
        [(value)]="inscriptionService.form.user.prenom"
        placeholder="Quel est ton prénom ?"
        [elementAttr]="{
          id: 'prenom',
          class:
            ' form-control ' + (formCheck.prenom?.hasError ? 'is-invalid' : '')
        }"
        (onValueChanged)="checkCanNextStep('prenom')"
      ></dx-text-box>
      <div
        id="prenom-error"
        class="is-invalid"
        *ngIf="formCheck.prenom?.hasError"
      >
        {{ formCheck.prenom.message }}
      </div>
      <!-- <input type="text" value="" class=" form-control" data-dashlane-rid="3439a3ce69744d4a" data-kwimpalastatus="alive" data-kwimpalaid="1654450318279-1" data-inscriptionService.form.user-type="name,first"> -->
    </div>
    <div class="col-lg-6 form-group">
      <label for="nom">Nom*</label>
      <dx-text-box
        [(value)]="inscriptionService.form.user.nom"
        placeholder="Quel est ton nom ?"
        [elementAttr]="{
          id: 'nom',
          class:
            ' form-control ' + (formCheck.nom?.hasError ? 'is-invalid' : '')
        }"
        (onValueChanged)="checkCanNextStep('nom')"
      ></dx-text-box>
      <div id="nom-error" class="is-invalid" *ngIf="formCheck.nom?.hasError">
        {{ formCheck.nom.message }}
      </div>
    </div>
    <div class="col-lg-6 form-group">
      <label for="nom">Date de naissance*</label>
      <dx-date-box
        applyValueMode="useButtons"
        [(value)]="inscriptionService.form.user.dateNaissance"
        [max]="now"
        placeholder="Quelle est ta date de naissance ?"
        [elementAttr]="{
          id: 'dateNaissance',
          class:
            ' form-control ' +
            (formCheck.dateNaissance?.hasError ? 'is-invalid' : '')
        }"
        (onValueChanged)="checkCanNextStep('dateNaissance')"
      >
      </dx-date-box>
      <!-- <dx-text-box
        [(value)]="inscriptionService.form.user.dateNaissance"
        placeholder="dateNaissance"
        [elementAttr]="{
          id: 'dateNaissance',
          class:
            ' form-control ' + (formCheck.dateNaissance?.hasError ? 'is-invalid' : '')
        }"
        (onValueChanged)="checkCanNextStep('nom')"
      ></dx-text-box> -->
      <div
        id="dateNaissance-error"
        class="is-invalid"
        *ngIf="formCheck.dateNaissance?.hasError"
      >
        {{ formCheck.dateNaissance.message }}
      </div>
    </div>
    <!-- <div class="col-lg-6 form-group">
    <label class="sr-only">Username</label>
    <dx-text-box [(value)]="inscriptionService.form.user.username"></dx-text-box>
    <input type="text" value="" placeholder="Username" class=" form-control" data-dashlane-rid="dc1becfb7f82a6c1" data-kwimpalastatus="alive" data-kwimpalaid="1654450318279-3" data-inscriptionService.form.user-type="username,new">
    </div>
    <div class="col-lg-6 form-group">
    <label class="sr-only">Password</label>
    <dx-text-box [(value)]="inscriptionService.form.user.password"></dx-text-box>
    <input type="password" value="" placeholder="Password" class=" form-control" data-dashlane-rid="0ddcdf8c7d903194" data-kwimpalastatus="alive" data-kwimpalaid="1654450318279-0" data-inscriptionService.form.user-type="password,new">
    </div> -->
    <!-- <div class="col-lg-12 form-group">
      <label for="adresse">Renseignez votre adresse</label>
      <dx-text-box
        [(value)]="inscriptionService.form.user.adresse"
        placeholder="Renseignez votre adresse"
        [elementAttr]="{
          id: 'email',
          class:
            ' form-control ' + (formCheck.adresse?.hasError ? 'is-invalid' : '')
        }"
        (onValueChanged)="checkCanNextStep('adresse')"
      ></dx-text-box>
      <div id="adresse-error" class="is-invalid" *ngIf="formCheck.adresse?.hasError">{{ formCheck.adresse.message}}</div>
    </div>
    <div class="col-lg-6 form-group">
      <label for="adresseAlt">Appartement,Etage,Batiment...</label>
      <dx-text-box
        [(value)]="inscriptionService.form.user.adresseAlt"
        placeholder="Appartement,Etage,Batiment..."
        [elementAttr]="{
          class:
            ' form-control '
        }"
        (onValueChanged)="checkCanNextStep('adresseAlt')"
      ></dx-text-box>
   </div> -->
    <div class="col-lg-6 form-group">
      <label for="pays">Territoire*</label>
      <dx-select-box
        [items]="territoireList"
        [(value)]="inscriptionService.form.user.pays"
        valueExpr="name"
        displayExpr="name"
        placeholder="Quelle est ton territoire ?"
        [elementAttr]="{
          class:
            ' form-control ' + (formCheck.pays?.hasError ? 'is-invalid' : '')
        }"
        (onValueChanged)="checkCanNextStep('pays'); refreshVilles(true)"
      ></dx-select-box>
      <!-- <dx-text-box
        [(value)]="inscriptionService.form.user.pays"
        placeholder="Pays"
        [elementAttr]="{
          class:
            ' form-control ' + (formCheck.pays?.hasError ? 'is-invalid' : '')
        }"
        (onValueChanged)="checkCanNextStep('pays')"
      ></dx-text-box> -->
      <div id="pays-error" class="is-invalid" *ngIf="formCheck.pays?.hasError">
        {{ formCheck.pays.message }}
      </div>
    </div>
    <div class="col-lg-6 form-group">
      <label for="ville">Ville*</label>
      <dx-select-box
        [items]="villeList"
        [(value)]="inscriptionService.form.user.ville"
        valueExpr="name"
        displayExpr="name"
        placeholder="Quelle est ta ville ?"
        [elementAttr]="{
          class:
            ' form-control ' + (formCheck.ville?.hasError ? 'is-invalid' : '')
        }"
        (onValueChanged)="checkCanNextStep('ville'); refreshQuartiers(true)"
        [readOnly]="!inscriptionService.form.user.pays || !villeList.length"
        *ngIf="
          !inscriptionService.form.user.pays ||
          (inscriptionService.form.user.pays && villeList.length)
        "
      ></dx-select-box>
      <dx-text-box
        *ngIf="inscriptionService.form.user.pays && !villeList.length"
        [(value)]="inscriptionService.form.user.ville"
        placeholder="Ville"
        [elementAttr]="{
          class:
            ' form-control ' + (formCheck.ville?.hasError ? 'is-invalid' : '')
        }"
        (onValueChanged)="checkCanNextStep('ville')"
      ></dx-text-box>
      <div
        id="ville-error"
        class="is-invalid"
        *ngIf="formCheck.ville?.hasError"
      >
        {{ formCheck.ville.message }}
      </div>
      <!-- <input type="text" value="" class=" form-control" data-dashlane-rid="eabb54695b057fad" data-kwimpalastatus="alive" data-kwimpalaid="1654450318279-5" data-inscriptionService.form.user-type="address,city"> -->
    </div>
    <div class="col-lg-6 form-group">
      <label for="quartier">Quartier*</label>
      <dx-select-box
        [items]="quartierList"
        [(value)]="inscriptionService.form.user.quartier"
        valueExpr="name"
        displayExpr="name"
        placeholder="Quelle est ton quartier ?"
        [elementAttr]="{
          class:
            ' form-control ' +
            (formCheck.quartier?.hasError ? 'is-invalid' : '')
        }"
        (onValueChanged)="checkCanNextStep('quartier')"
        [readOnly]="!inscriptionService.form.user.pays || !quartierList.length"
        *ngIf="
          !inscriptionService.form.user.pays ||
          (inscriptionService.form.user.pays && quartierList.length)
        "
      ></dx-select-box>
      <dx-text-box
        *ngIf="inscriptionService.form.user.pays && !quartierList.length"
        [(value)]="inscriptionService.form.user.quartier"
        placeholder="Quartier"
        [elementAttr]="{
          class:
            ' form-control ' +
            (formCheck.quartier?.hasError ? 'is-invalid' : '')
        }"
        (onValueChanged)="checkCanNextStep('quartier')"
      ></dx-text-box>
      <div
        id="quartier-error"
        class="is-invalid"
        *ngIf="formCheck.quartier?.hasError"
      >
        {{ formCheck.quartier.message }}
      </div>
      <!-- <input type="text" value="" class=" form-control" data-dashlane-rid="eabb54695b057fad" data-kwimpalastatus="alive" data-kwimpalaid="1654450318279-5" data-inscriptionService.form.user-type="address,city"> -->
    </div>
    <!-- <div class="col-lg-6 form-group">
      <label for="codePostal">Code Postal</label>
      <dx-text-box
        [(value)]="inscriptionService.form.user.codePostal"
        mask="AAAAA"
        placeholder="Postcode / Zip"
        [elementAttr]="{
          class:
            ' form-control ' +
            (formCheck.codePostal?.hasError ? 'is-invalid' : '')
        }"
        (onValueChanged)="checkCanNextStep('codePostal')"
      ></dx-text-box>
      <div id="codePostal-error" class="is-invalid" *ngIf="formCheck.codePostal?.hasError">{{ formCheck.codePostal.message}}</div>
      </div> -->
    <div class="col-lg-6 form-group">
      <label for="email">Email*</label>
      <dx-text-box
        [(value)]="inscriptionService.form.user.email"
        placeholder="Email"
        [readOnly]="currentUser"
        [elementAttr]="{
          class:
            ' form-control ' + (formCheck.email?.hasError ? 'is-invalid' : '')
        }"
        (onValueChanged)="checkCanNextStep('email')"
      ></dx-text-box>
      <div
        id="email-error"
        class="is-invalid"
        *ngIf="formCheck.email?.hasError"
      >
        {{ formCheck.email.message }}
      </div>
      <!-- <div class="btn btn-sm" *ngIf="!alreadyInscription && formCheck.email?.hasError" (click)="modalResumeVisible = true">voir mon inscription</div> -->
      <div class="btn btn-sm" *ngIf="alreadyInscription" (click)="modalResumeVisible = true">voir mon inscription</div>
      <!-- <input type="text" value=""  class=" form-control" data-dashlane-rid="762b40f5326ce680" data-kwimpalastatus="alive" data-kwimpalaid="1654450318279-8" data-inscriptionService.form.user-type="email"> -->
    </div>
    <div class="col-lg-6 form-group">
      <label for="email">Téléphone*</label>
      <dx-text-box
        [(value)]="inscriptionService.form.user.telephone"
        mask="0000000000"
        placeholder="Quel est ton numero de telephone ?"
        [elementAttr]="{
          class:
            ' form-control ' +
            (formCheck.telephone?.hasError ? 'is-invalid' : '')
        }"
        (onValueChanged)="checkCanNextStep('telephone')"
      ></dx-text-box>
      <div
        id="telephone-error"
        class="is-invalid"
        *ngIf="formCheck.telephone?.hasError"
      >
        {{ formCheck.telephone.message }}
      </div>
      <!-- <input type="text" value="" class=" form-control" data-dashlane-rid="8c6762b184608f5f" data-kwimpalastatus="alive" data-kwimpalaid="1654450318279-9" data-inscriptionService.form.user-type="phone"> -->
    </div>
    <div class="col-lg-6 form-group">
      <label for="email">Catégorie Socioprofessionnelle*</label>
      <dx-select-box
        [items]="cspList"
        [(value)]="inscriptionService.form.user.csp"
        mask="0000000000"
        placeholder="Quelle est ta catégorie Socioprofessionnelle ?"
        [elementAttr]="{
          class:
            ' form-control ' + (formCheck.csp?.hasError ? 'is-invalid' : '')
        }"
        (onValueChanged)="checkCanNextStep('csp')"
      ></dx-select-box>
      <div id="csp-error" class="is-invalid" *ngIf="formCheck.csp?.hasError">
        {{ formCheck.csp.message }}
      </div>
      <!-- <input type="text" value="" class=" form-control" data-dashlane-rid="8c6762b184608f5f" data-kwimpalastatus="alive" data-kwimpalaid="1654450318279-9" data-inscriptionService.form.user-type="phone"> -->
    </div>
    <div class="col-12 mb-2">
      <h5 class="strong mb-0">Conditions générales et règlement</h5>
    </div>
    <div class="col-12 form-group cgu d-flex align-items-start gap-2">
      <dx-check-box
        [(value)]="cguAccepted"
        [elementAttr]="{
          id: 'cgu',
          name: 'cgu'
        }"
        (onValueChanged)="checkCanNextStep('cguAccepted')"
        class="mt-1 flex-shrink-0"
      ></dx-check-box>
      <label for="cgu"
        >Je déclare sur l'honneur avoir pris connaissance des
        <span class="strong orange cursor-pointer text-decoration-underline" (click)="modalCguVisible = true"
          >Conditions Générales d'Utilisation</span
        >
        et les accepter ainsi que du
        <span class="strong orange cursor-pointer text-decoration-underline" (click)="modalRgpdVisible = true"
          >Règlement général sur la protection des données</span
        >
        et les accepter.</label
      >
      <div
        id="cguAccepted-error"
        class="is-invalid"
        *ngIf="formCheck.cguAccepted?.hasError"
      >
        {{ formCheck.cguAccepted.message }}
      </div>
    </div>
    <!-- <div class="col-lg-12 form-group">
    <button class="btn" type="button" data-dashlane-rid="346a1470ec968b03" data-dashlane-label="true" data-inscriptionService.form.user-type="other">Register New Account </button>
    <button type="button" class="btn btn-danger m-l-10" data-dashlane-rid="030a6c0628188dd7" data-dashlane-label="true" data-inscriptionService.form.user-type="other">Cancel</button>
    </div> -->
  </div>
</div>

<div class="modal-footer">
  <div *ngIf="currentUser">
    <div class="">
      connecté en tant que {{ currentUser.username }}
      <i class="fa fa-user"></i>
    </div>
  </div>
  <button class="btn btn-danger btn-b" type="button" (click)="close()" *ngIf="inscriptionService.form.step <= 1">
    annuler
  </button>
  <button class="btn btn-danger btn-b" type="button" (click)="prevStep()" *ngIf="inscriptionService.form.step >  1">
   retour
  </button>
  <button
    class="btn btn-b"
    [class.btn-success]="canNextStep"
    type="button"
    (click)="nextStep()"
  >
    Continuer
  </button>
</div>

<div class="modal fade show d-block" id="modalRgpd" *ngIf="modalRgpdVisible">
  <div class="bg-overlay"></div>
  <div class="modal-dialog modal-lg modal-center">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="modal-label-3" class="modal-title">Protection des données</h4>
        <!-- <button aria-hidden="true" data-dismiss="modal" class="close" type="button">×</button> -->
      </div>
      <div class="modal-body maxfullscreen">
        <rgpd></rgpd>
      </div>
      <div class="modal-footer">
        <button
          class="btn btn-logement"
          type="button"
          (click)="modalRgpdVisible = false"
        >
          retour
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal fade show d-block" id="modalCgu" *ngIf="modalCguVisible">
  <div class="bg-overlay"></div>
  <div class="modal-dialog modal-lg modal-center">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="modal-label-3" class="modal-title">Conditions Générales</h4>
        <!-- <button aria-hidden="true" data-dismiss="modal" class="close" type="button">×</button> -->
      </div>
      <div class="modal-body maxfullscreen">
        <cgu></cgu>
      </div>
      <div class="modal-footer">
        <button
          class="btn btn-logement"
          type="button"
          (click)="modalCguVisible = false"
        >
          retour
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal fade show d-block" id="modalAlreadyInscription" *ngIf="modalAlreadyInscriptionVisible">
  <div class="bg-overlay"></div>
  <div class="modal-dialog modal-lg modal-center">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="modal-label-3" class="modal-title">Déjà inscrit ?</h4>
        <!-- <button aria-hidden="true" data-dismiss="modal" class="close" type="button">×</button> -->
      </div>
      <div class="modal-body maxfullscreen">
        <p> Renseigne ton adresse email pour retrouver ton inscription. </p>
        <div class="col-lg-12 form-group">
          <label for="email">Email*</label>
          <dx-text-box
            [(value)]="inscriptionService.form.user.email"
            placeholder="Email"
            [readOnly]="currentUser"
            (onValueChanged)="checkCanNextStep('email')"
          ></dx-text-box>
          <div
            id="email-error"
            class="is-invalid"
            *ngIf="alreadyInscriptionMessage"
          >
            {{ alreadyInscriptionMessage }}
          </div>
          <div class="btn btn-sm" *ngIf="!alreadyInscription" (click)="getInscriptionByEmail(inscriptionService.form.user.email)">Vérifier mon inscription</div>
          <div class="btn btn-sm" *ngIf="alreadyInscription" (click)="modalResumeVisible = true">voir mon inscription</div>
          <!-- <input type="text" value=""  class=" form-control" data-dashlane-rid="762b40f5326ce680" data-kwimpalastatus="alive" data-kwimpalaid="1654450318279-8" data-inscriptionService.form.user-type="email"> -->
        </div>
      </div>
      <div class="modal-footer">
        <button
          class="btn btn-logement"
          type="button"
          (click)="modalAlreadyInscriptionVisible = false"
        >
          retour
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade show d-block" id="modalResume" *ngIf="modalResumeVisible && alreadyInscription">
  <div class="bg-overlay"></div>
  <div class="modal-dialog modal-lg modal-center">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="modal-label-3" class="modal-title">Inscription</h4>
        <!-- <button aria-hidden="true" data-dismiss="modal" class="close" type="button">×</button> -->
      </div>
        <div class="modal-body maxfullscreen">
          <div class="row">
            <div class="col-lg-12">
              <!-- <h5>Merci!</h5> -->
              <p>
                <strong>Ton inscription a déjà été prise en compte.</strong>
                <br />
              </p>
              <!-- {{ alreadyInscription | json }} -->
              <ng-container *ngFor="let item of alreadyInscription.evenementLieux">
                <p>
                  Nous t'attendons le
                  {{ item.dateDebut | date: "shortDate" }} dès 9h à :<br />
                  {{ item.description }}
                </p>
              </ng-container>

              <p>
                Suis toutes les dernières actualités du forum sur les réseaux
                sociaux du CLLAJ Martinique !
              </p>

              <p *ngIf="hasOnlySP() || hasOnlyD() || hasOnlySPD()">
                <ng-container *ngIf="hasOnlySP()">
                  <strong>Comme tu as choisi l'activité Speed Dating</strong>,
                  <br />Dépose ta demande sur la plateforme D'Clic Jeune.<br />
                  Puis rends-toi au Forum, avec <strong class="text-red">ta pièce d'identité</strong>.<br /><br />
                  <strong
                    >Clique sur le bouton ci-dessous pour continuer:</strong
                  ><br />
                  <a
                    href="https://cllaj-martinique.fr/annonces/inscription.php?ref=Forum_SP"
                    target="_blank"
                    class="btn btn-b"
                    ><i class="fas fa-right"></i> Plateforme D'Clic Jeune</a
                  ></ng-container
                >
                <ng-container *ngIf="hasOnlyD()">
                  <strong>Comme tu as choisi l'activité Traitement de la demande</strong>, <br />Consulte les annonces du CLLAJ Martinique sur la
                  plateforme D'Clic Jeune. <br />Dépose ta demande sur la
                  plateforme D'Clic Jeune.<br />
                  Puis rends-toi au Forum, avec <strong class="text-red">ta pièce d'identité</strong>.<br /><br />
                  <strong
                    >Clique sur le bouton ci-dessous pour continuer:</strong
                  ><br />
                  <a
                    href="https://cllaj-martinique.fr/annonces/annonces-logement.php?ref=Forum_D"
                    target="_blank"
                    class="btn btn-b"
                    ><i class="fas fa-right"></i>Plateforme D'Clic Jeune</a
                  ></ng-container
                >
                <ng-container *ngIf="hasOnlySPD()">
                  <strong
                    >Comme tu as choisi l'activité Speed Dating et Délivrance
                    des offres</strong
                  >, <br />Consulte les annonces du CLLAJ Martinique sur la
                  plateforme D'Clic Jeune. <br />Dépose ta demande sur la
                  plateforme D'Clic Jeune.<br />
                  Puis rends-toi au Forum, avec <strong class="text-red">ta pièce d'identité</strong>.<br /><br />
                  <strong
                    >Clique sur le bouton ci-dessous pour continuer:</strong
                  ><br />
                  <a
                    href="https://cllaj-martinique.fr/annonces/annonces-logement.php?ref=Forum_SPD"
                    target="_blank"
                    class="btn btn-b"
                    ><i class="fas fa-right"></i> Plateforme D'Clic Jeune</a
                  ></ng-container
                >
              </p>

              <!-- {{ finalForm | json}} -->
            </div>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-success btn-b"
              type="button"
              (click)="modalResumeVisible = false"
            >
              retour
            </button>
          </div>
      </div>
    </div>
  </div>
</div>
